import React from "react"
import ShellStationPage from "@geome/shell-station-page-ts"

const LocationPage = (props) => {
  return <ShellStationPage {...props} />
}

export default LocationPage
